<template>
  <div class="page-query">
    <div class="page-container">
        <template>
         <form-button name="返回" @click="$router.go(-1)" />
        </template>
    </div>
    <div class="table-container">
      <TableCommon
        title="红票"
        :custome-config="() => vxeShowCustom('xTable')"
        export-all
        export-page
      >
        <template #button>
          <!-- <table-button name="add" tip="新增" @click="toAdd" /> -->
          <!-- <table-button name="export" tip="打印" @click="printDialog" /> -->
        </template>
        <vxe-grid
          ref="redTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="240"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridRedOptions.columns"
          :data="gridRedOptions.data"
          @cell-dblclick="cellRedClick"
          @filter-change="filterChange"
        >
         <template #warehouse="{ row }">
            <el-select v-model="row.warehouse" size="mini" disabled>
              <el-option
                v-for="item in selectDataOptions['A0039']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>
       <TableCommon
        title="蓝票"
        :custome-config="() => vxeShowCustom('xTable')"
        export-all
        export-page
      >
        <template #button>
          <!-- <table-button name="add" tip="新增" @click="toAdd" /> -->
          <!-- <table-button name="export" tip="打印" @click="printDialog" /> -->
        </template>
        <vxe-grid
          ref="blueTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="240"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :columns="gridBlueOptions.columns"
          :data="gridBlueOptions.data"
          @cell-dblclick="cellBlueClick"
          @filter-change="filterChange"
        >
         <template #warehouse="{ row }">
            <el-select v-model="row.warehouse" size="mini" disabled>
              <el-option
                v-for="item in selectDataOptions['A0039']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <!-- use_quantity -->
          <template #ck_num="{ row }">
            <el-select v-model="row.ck_num" size="mini" @change="(e) => {cknumChange(e,row)}">
              <el-option
                v-for="item in row.sel_num"
                :key="item.ck_num"
                :label="item.ck_num"
                :value="item.ck_num"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="浏览制票通知单"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />
      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmPrint"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiRedDataGet, apiRedDetailDataGet } from '@/api/sap/make-invoice-sap'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { printInvoice } from '@/api/sap/make-invoice-sap'
import { hexToBytes } from '@/utils/frontExport'
import tableMixins from '@/utils/tableMixins'

export default {
  mixins: [tableMixins],
  props: {
    invoInfoid: {
      type: String,
      default: ''
    },
    ticketType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showDialog: false,
      url: '',
      gridRedOptions: {
        columns: [
          // { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'invo_infoid', title: '制票单号', width: 120 },
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'use_quantity', title: '开票数量', width: 120 },
          { field: 'use_zzfld9', title: '开票件数', width: 80 },
          { field: 'use_bot', title: '开票瓶数', width: 80 },
          { field: 'zzfld00002t', title: '单位', width: 80 },
          { field: 'zzfld00002e', title: '税率', width: 80 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120 },
          { field: 'zzfld00002a_text', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 },
          { field: 'object_id', title: '销售订单号', width: 120 },
          { field: 'number_int', title: '销售订单号行项目', width: 150 },
          { field: 'cust_name', title: '订单客户', width: 120 },
          { field: 'reward_type_text', title: '奖励类型', width: 120 },
          { field: 'reward_number', title: '奖励编号', width: 120 },
          { field: 'reward_name', title: '项目/计划编号', width: 120 },
          { field: 'send_qty', title: '已发运件数', width: 120 },
          { field: 'guaranty', title: '随货保证金', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120, slots: { default: 'warehouse' }, params: { bgEdit: true }},
          { field: 'remark', title: '备注', width: 120 },
        ],
        data: []
      },
      gridBlueOptions: {
        columns: [
          // { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'invo_infoid', title: '制票单号', width: 120 },
          { field: 'zzfld00002q_text', title: '计划类型', width: 120 },
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'ck_num', title: '出库数量', width: 120, slots: { default: 'ck_num' }, params: { bgEdit: true } },
          { field: 'use_quantity', title: '开票数量', width: 120},
          { field: 'use_zzfld9', title: '开票件数',type:'input', width: 80 , editRender:{name:'input',props:{type:'number'},enanled:true}},
          { field: 'use_bot', title: '开票瓶数', width: 80 , editRender:{name:'input',props:{type:'number'},enanled:true}},
          { field: 'zzfld00002t', title: '单位', width: 80 },
          { field: 'zzfld00002e', title: '税率', width: 80 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120 },
          { field: 'zzfld00002a_text', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 , editRender:{name:'input',props:{type:'number'},enanled:true}},
          { field: 'object_id', title: '销售订单号', width: 120 },
          { field: 'number_int', title: '销售订单号行项目', width: 150 },
          { field: 'cust_name', title: '订单客户', width: 120 },
          { field: 'reward_type_text', title: '奖励类型', width: 120 },
          { field: 'reward_number', title: '奖励编号', width: 120 },
          { field: 'reward_name', title: '项目/计划编号', width: 120 },
          { field: 'send_qty', title: '已发运件数', width: 120 },
          { field: 'guaranty', title: '随货保证金', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120, params: { bgEdit: true }},
          { field: 'remark', title: '备注', width: 120 },
        ],
        data: []
      },
      catchData: [],
      filterVal: '',
      selectDataOptions: {},
      redRushId: '',
      loading: false,
    }
  },
  watch: {
    invoInfoid(newVal) {
      if (newVal) {
        console.log(`output->newVal`,newVal)
        this.ticketType === 'RED' && this.gridRedOptions.data.forEach(v => (v.invo_infoid = newVal))
        this.ticketType === 'BLUE' && this.gridBlueOptions.data.forEach(v => (v.invo_infoid = newVal))
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0039')
    if (this.$route.query.id) {
      this.getData(this.$route.query.id)
    }
  },
  methods: {
    cknumChange(e,row){
      row.use_zzfld9 = e;
      row.use_quantity = row.use_zzfld9 * row.zzfld00002w;
      row.net_value = row.use_quantity * row.net_price;
      return row
      // this.gridBlueOptions.data.map(item => {
      //   if(item.invo_infoid == row.invo_infoid){
      //     item.use_zzfld9 = e;
      //     item.use_quantity = item.use_zzfld9 * item.zzfld00002w;
      //     item.net_value = item.use_quantity * item.net_price
      //   }
      // })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    getData(id) {
      this.loading = true
      apiRedDataGet({red_rush_id: id,user_bp: this.$store.getters.role.USER_BP,}).then(res => {
        if(res.msgtype === 'E') {
          this.$message.error(res.message)
          this.loading = false
          return
        }
        this.gridRedOptions.data = res.data.red_item
        this.gridBlueOptions.data = res.data.blue_item
        this.redRushId = res.data.red_rush_id
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAdd() {

    },
    filterChange({ $event, values }) {
      const [value] = values
      this.filterVal = value
      // this.filterData()
    },
    filterData() {
      if (this.filterVal === 'notempty') { // 返回所有有单号的数据
        // 隐藏空数据
        this.gridOptions.data = this.catchData.filter(v => v.invo_infoid)
      } else if (this.filterVal === 'empty') { // 返回空数据
        // 隐藏有单号的数据
        this.gridOptions.data = this.catchData.filter(v => !v.invo_infoid)
        console.log(this.gridOptions.data)
      } else { // 返回所有数据
        this.gridOptions.data = this.catchData
      }
    },
    printDialog() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (!data.length) return this.$message.warning('请选择有效数据！')
      printInvoice({
        user_bp: this.$store.getters.role.USER_BP,
        invo_infoid: data.map(v => v.invo_infoid)
      }).then(res => {
        this.showDialog = true
        var uint8Array = new Uint8Array(hexToBytes(res.data))
        var blob = new Blob([uint8Array], { type: 'application/pdf' })
        this.url = URL.createObjectURL(blob)
      })
    },
    confirmPrint() {
      this.$confirm('确认已经打印此制票通知单！', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(res => {
        const data = this.$refs.xTable.getCheckboxRecords()
        printInvoice({
          user_bp: this.$store.getters.role.USER_BP,
          invo_infoid: data.map(v => v.invo_infoid),
          mode: 'X'
        }).then(res => {
          this.showDialog = false
          this.queryData()
        })
      })
    },
    cellRedClick({ row }) {
      this.getInvoiceDetail(this.gridRedOptions.data, this.redRushId, 'RED')
      // this.$emit('changeActive', 'entry', null, this.gridRedOptions.data, this.redRushId, 'RED')
    },
    cellBlueClick({ row }) {
      const data = this.gridBlueOptions.data
      const isNum = data.every(item => item.ck_num)
      if (!isNum) {
        return this.$message.warning('请先选择出库数量！')
      }
      this.getInvoiceDetail(this.gridBlueOptions.data, this.redRushId, 'BLUE')
      // this.$emit('changeActive', 'entry', null, this.gridBlueOptions.data, this.redRushId, 'BLUE')
    },
    async getInvoiceDetail(selectData, redRushId, ticketType) {
      this.loading = true
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        item: selectData,
        mode: ticketType,
        red_rush_id: redRushId
      }
      const { data, additional, msgtype, message } = await apiRedDetailDataGet(params)
      if(msgtype === 'E') {
        this.$message.error(message)
        this.loading = false
        return
      }
      this.$emit('changeActive', 'entry', null, selectData, redRushId, ticketType)
      this.loading = false
    },
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  margin: 0px 24px 16px;
  padding: 10px 24px;
  background: #fff;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/CreateRedOrder.vue